/**
 * 電子發票證明聯資料 schema — REQ-20260602001 Phase 2C-3。
 *
 * server 組好「顯示欄位 + 1D 條碼內容 + 兩段式 QR 內容」,
 * 前端只負責把字串渲染成 QR 圖 / Code39 條碼 + 排版列印。
 * REQ-20260915003 起條碼與 QR 內容直接採用 ezPay 開立時回傳的值,系統不再自行計算。
 */
import { z } from 'zod';

export const InvoiceCertificateLineSchema = z.object({
  description: z.string(),
  quantity: z.string(),
  unitPrice: z.string(),
  amount: z.string(),
});
export type InvoiceCertificateLine = z.infer<typeof InvoiceCertificateLineSchema>;

export const InvoiceCertificateSchema = z.object({
  invoiceNo: z.string(),
  /** 期別顯示,如「115年05-06月」 */
  periodLabel: z.string(),
  /** 開立日期顯示,如「中華民國115年06月02日」 */
  invoiceDateLabel: z.string(),
  invoiceTime: z.string(),
  randomNumber: z.string(),
  sellerTaxId: z.string(),
  sellerName: z.string(),
  buyerTaxId: z.string().nullable(),
  salesAmount: z.string(),
  taxAmount: z.string(),
  totalAmount: z.string(),
  /** 一維條碼(Code39)內容 */
  barcode1D: z.string(),
  /** 左 / 右 二維條碼內容 */
  qrLeft: z.string(),
  qrRight: z.string(),
  lines: z.array(InvoiceCertificateLineSchema),
});
export type InvoiceCertificate = z.infer<typeof InvoiceCertificateSchema>;
